const Gtm = () => {
  const $body = $('body')
  if(!$body.hasClass('page-template-template-search') ) {
    if(!$body.hasClass('is-development-environment')) {
      window.dataLayer.push({
        event: 'page_load',
        // eslint-disable-next-line no-undef
        section: gtm_object.section,
        // eslint-disable-next-line no-undef
        sub_section: gtm_object.section,
        // eslint-disable-next-line no-undef
        template_name: gtm_object.section,
      })
    }
  }
}

export default Gtm;



// WEBPACK FOOTER //
// ./scripts/components/Gtm.js